import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-creature-type-variants-inline',
  templateUrl: './creature-type-variants-inline.component.html',
  styleUrls: ['./creature-type-variants-inline.component.sass']
})
export class CreatureTypeVariantsInlineComponent implements OnChanges {
  @Input() variants: any[] = [];
  @Input() field: any;
  @Output() onChange = new EventEmitter<any[]>();

  showForm: boolean = false;
  isCreating: boolean = false;
  errorMessage: string | null = null;

  newVariant: any = { name: '', enabled: false, env: [] };

  // Existing variant search
  searchResults: any[] = [];
  searchQuery: string = '';

  envOptions = [
    { label: 'dev', value: 'dev' },
    { label: 'qa', value: 'qa' },
    { label: 'prod', value: 'prod' },
    { label: 'test', value: 'test' },
  ];

  constructor(private dataService: DataService) {}

  ngOnChanges(changes: SimpleChanges) {
    // Clear search results when variants list updates
    if (changes['variants']) {
      this.searchResults = [];
      this.searchQuery = '';
    }
  }

  getVariantName(v: any): string {
    return v?.name || v?.internalName || '';
  }

  toggleForm() {
    this.showForm = !this.showForm;
    if (this.showForm) {
      this.newVariant = { name: '', enabled: false, env: [] };
      this.errorMessage = null;
    }
  }

  async searchVariants(event: any) {
    const query = event.query ?? '';
    try {
      const numericId = query && !isNaN(Number(query)) ? Number(query) : null;
      const searchQuery = query
        ? { $or: [{ name: { $regex: query, $options: 'i' } }, ...(numericId !== null ? [{ id: numericId }] : [])] }
        : {};
      const result = await this.dataService.getAllOfTypeAsync(
        'variants',
        {
          query: searchQuery,
          select: '_id id name internalName',
          sort: { name: 1 },
        }
      );
      const existing = new Set((this.variants || []).map((v: any) => v._id?.toString() || v?.toString()));
      this.searchResults = (result || []).filter((v: any) => !existing.has(v._id?.toString()));
    } catch {
      this.searchResults = [];
    }
  }

  addExistingVariant(event: any) {
    const variant = event?.value ?? event;
    if (!variant?._id) return;
    const updated = [...(this.variants || []), variant];
    this.onChange.emit(updated);
    this.searchQuery = '';
    this.searchResults = [];
  }

  async createVariant() {
    this.isCreating = true;
    this.errorMessage = null;
    try {
      const created = await this.dataService.addNewRecord('variants', this.newVariant);
      // Ensure name is present — the API may return a lean document without
      // the virtual or the field might be in a different key
      if (!created.name) created.name = this.newVariant.name;
      const updated = [...(this.variants || []), created];
      this.onChange.emit(updated);
      this.newVariant = { name: '', enabled: false, env: [] };
      this.showForm = false;
    } catch (e: any) {
      this.errorMessage = e?.error?.message || 'Failed to create variant.';
    } finally {
      this.isCreating = false;
    }
  }

  removeVariant(index: number) {
    const updated = [...(this.variants || [])];
    updated.splice(index, 1);
    this.onChange.emit(updated);
  }
}
